(ns quuppa.ui.tabs
  "https://react-bootstrap.github.io/components/tabs/"
  (:require [reagent.core :as r]
            ["react-bootstrap/Tabs$default" :as Tabs]
            ["react-bootstrap/Tab$default" :as Tab]
            ["react-bootstrap/TabContainer$default" :as TabContainer]
            ["react-bootstrap/TabContent$default" :as TabContent]
            ["react-bootstrap/TabPane$default" :as TabPane]))

(def tabs (r/adapt-react-class Tabs))
(def tab (r/adapt-react-class Tab))
(def tab-container (r/adapt-react-class TabContainer))
(def tab-content (r/adapt-react-class TabContent))
(def tab-pane (r/adapt-react-class TabPane))
